module.exports = __webpack_public_path__ + "assets/media/swallow_practice_mix.61861c90.mp4";